'use strict';
var __createBinding =
	(this && this.__createBinding) ||
	(Object.create
		? function (o, m, k, k2) {
				if (k2 === undefined) k2 = k;
				Object.defineProperty(o, k2, {
					enumerable: true,
					get: function () {
						return m[k];
					},
				});
		  }
		: function (o, m, k, k2) {
				if (k2 === undefined) k2 = k;
				o[k2] = m[k];
		  });
var __setModuleDefault =
	(this && this.__setModuleDefault) ||
	(Object.create
		? function (o, v) {
				Object.defineProperty(o, 'default', {enumerable: true, value: v});
		  }
		: function (o, v) {
				o['default'] = v;
		  });
var __importStar =
	(this && this.__importStar) ||
	function (mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null)
			for (var k in mod)
				if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		__setModuleDefault(result, mod);
		return result;
	};
var __awaiter =
	(this && this.__awaiter) ||
	function (thisArg, _arguments, P, generator) {
		function adopt(value) {
			return value instanceof P
				? value
				: new P(function (resolve) {
						resolve(value);
				  });
		}
		return new (P || (P = Promise))(function (resolve, reject) {
			function fulfilled(value) {
				try {
					step(generator.next(value));
				} catch (e) {
					reject(e);
				}
			}
			function rejected(value) {
				try {
					step(generator['throw'](value));
				} catch (e) {
					reject(e);
				}
			}
			function step(result) {
				result.done
					? resolve(result.value)
					: adopt(result.value).then(fulfilled, rejected);
			}
			step((generator = generator.apply(thisArg, _arguments || [])).next());
		});
	};
Object.defineProperty(exports, '__esModule', {value: true});
exports.ApolloClientManager = void 0;
const auth_1 = require('../../auth');
const globalTypes_1 = require('../../gqlTypes/globalTypes');
const CheckoutMutations = __importStar(require('../../mutations/checkout'));
const CheckoutQueries = __importStar(require('../../queries/checkout'));
const ShopQueries = __importStar(require('../../queries/shop'));
const utils_1 = require('../../utils');
class ApolloClientManager {
	constructor(client) {
		this.getCheckout = (checkoutToken) =>
			__awaiter(this, void 0, void 0, function* () {
				let checkout;
				try {
					checkout = yield new Promise((resolve, reject) => {
						if (this.isLoggedIn()) {
							const observable = this.client.watchQuery({
								fetchPolicy: 'network-only',
								query: CheckoutQueries.userCheckoutDetails,
							});
							observable.subscribe(
								(result) => {
									var _a;
									const {data, errors} = result;
									if (
										errors === null || errors === void 0
											? void 0
											: errors.length
									) {
										reject(errors);
									} else {
										resolve(
											(_a = data.me) === null || _a === void 0
												? void 0
												: _a.checkout,
										);
									}
								},
								(error) => {
									reject(error);
								},
							);
						} else if (checkoutToken) {
							const observable = this.client.watchQuery({
								fetchPolicy: 'network-only',
								query: CheckoutQueries.checkoutDetails,
								variables: {
									token: checkoutToken,
								},
							});
							observable.subscribe(
								(result) => {
									const {data, errors} = result;
									if (
										errors === null || errors === void 0
											? void 0
											: errors.length
									) {
										reject(errors);
									} else {
										resolve(data.checkout);
									}
								},
								(error) => {
									reject(error);
								},
							);
						} else {
							resolve(null);
						}
					});
					if (checkout) {
						return {
							data: this.constructCheckoutModel(checkout),
						};
					}
				} catch (error) {
					return {
						error,
					};
				}
				return {};
			});
		this.getRefreshedCheckoutLines = (checkoutlines) =>
			__awaiter(this, void 0, void 0, function* () {
				const idsOfMissingVariants =
					checkoutlines === null || checkoutlines === void 0
						? void 0
						: checkoutlines
								.filter((line) => !line.variant || !line.totalPrice)
								.map((line) => line.variant.id);
				const linesWithProperVariant =
					(checkoutlines === null || checkoutlines === void 0
						? void 0
						: checkoutlines.filter(
								(line) => line.variant && line.totalPrice,
						  )) || [];
				let variants;
				if (idsOfMissingVariants && idsOfMissingVariants.length) {
					try {
						const observable = this.client.watchQuery({
							query: CheckoutQueries.checkoutProductVariants,
							variables: {
								ids: idsOfMissingVariants,
							},
						});
						variants = yield new Promise((resolve, reject) => {
							observable.subscribe(
								(result) => {
									const {data, errors} = result;
									if (
										errors === null || errors === void 0
											? void 0
											: errors.length
									) {
										reject(errors);
									} else {
										resolve(data.productVariants);
									}
								},
								(error) => {
									reject(error);
								},
							);
						});
					} catch (error) {
						return {
							error,
						};
					}
				}
				const linesWithMissingVariantUpdated = variants
					? variants.edges.map((edge) => {
							var _a;
							const existingLine =
								checkoutlines === null || checkoutlines === void 0
									? void 0
									: checkoutlines.find(
											(line) => line.variant.id === edge.node.id,
									  );
							const variantPricing =
								(_a = edge.node.pricing) === null || _a === void 0
									? void 0
									: _a.price;
							const totalPrice = variantPricing
								? {
										gross: Object.assign(
											Object.assign({}, variantPricing.gross),
											{
												amount:
													variantPricing.gross.amount *
													((existingLine === null || existingLine === void 0
														? void 0
														: existingLine.quantity) || 0),
											},
										),
										net: Object.assign(Object.assign({}, variantPricing.net), {
											amount:
												variantPricing.net.amount *
												((existingLine === null || existingLine === void 0
													? void 0
													: existingLine.quantity) || 0),
										}),
								  }
								: null;
							return {
								id:
									existingLine === null || existingLine === void 0
										? void 0
										: existingLine.id,
								quantity:
									(existingLine === null || existingLine === void 0
										? void 0
										: existingLine.quantity) || 0,
								totalPrice,
								variant: {
									attributes: edge.node.attributes,
									id: edge.node.id,
									isAvailable: edge.node.isAvailable,
									name: edge.node.name,
									pricing: edge.node.pricing,
									product: edge.node.product,
									quantityAvailable: edge.node.quantityAvailable,
									sku: edge.node.sku,
								},
							};
					  })
					: [];
				const linesWithProperVariantUpdated = linesWithProperVariant.map(
					(line) => {
						var _a;
						const variantPricing =
							(_a = line.variant.pricing) === null || _a === void 0
								? void 0
								: _a.price;
						const totalPrice = variantPricing
							? {
									gross: Object.assign(
										Object.assign({}, variantPricing.gross),
										{amount: variantPricing.gross.amount * line.quantity},
									),
									net: Object.assign(Object.assign({}, variantPricing.net), {
										amount: variantPricing.net.amount * line.quantity,
									}),
							  }
							: null;
						return {
							id: line.id,
							quantity: line.quantity,
							totalPrice,
							variant: line.variant,
						};
					},
				);
				return {
					data: [
						...linesWithMissingVariantUpdated,
						...linesWithProperVariantUpdated,
					],
				};
			});
		this.getPaymentGateways = () =>
			__awaiter(this, void 0, void 0, function* () {
				let paymentGateways;
				try {
					paymentGateways = yield new Promise((resolve, reject) => {
						const observable = this.client.watchQuery({
							fetchPolicy: 'network-only',
							query: ShopQueries.getShopPaymentGateways,
						});
						observable.subscribe(
							(result) => {
								const {data, errors} = result;
								if (
									errors === null || errors === void 0 ? void 0 : errors.length
								) {
									reject(errors);
								} else {
									resolve(data.shop.availablePaymentGateways);
								}
							},
							(error) => {
								reject(error);
							},
						);
					});
					if (paymentGateways) {
						return {
							data: paymentGateways,
						};
					}
				} catch (error) {
					return {
						error,
					};
				}
				return {};
			});
		this.createCheckout = (email, lines, shippingAddress, billingAddress) =>
			__awaiter(this, void 0, void 0, function* () {
				var _a, _b, _c, _d, _e;
				try {
					const variables = {
						checkoutInput: {
							billingAddress: billingAddress && {
								city: billingAddress.city,
								companyName: billingAddress.companyName,
								country:
									globalTypes_1.CountryCode[
										(_a =
											billingAddress === null || billingAddress === void 0
												? void 0
												: billingAddress.country) === null || _a === void 0
											? void 0
											: _a.code
									],
								countryArea: billingAddress.countryArea,
								firstName: billingAddress.firstName,
								lastName: billingAddress.lastName,
								phone: billingAddress.phone,
								postalCode: billingAddress.postalCode,
								streetAddress1: billingAddress.streetAddress1,
								streetAddress2: billingAddress.streetAddress2,
								placeId: billingAddress.placeId,
								longitude: billingAddress.longitude,
								latitude: billingAddress.latitude,
							},
							email,
							lines,
							shippingAddress: shippingAddress && {
								city: shippingAddress.city,
								companyName: shippingAddress.companyName,
								country:
									globalTypes_1.CountryCode[
										(_b =
											shippingAddress === null || shippingAddress === void 0
												? void 0
												: shippingAddress.country) === null || _b === void 0
											? void 0
											: _b.code
									],
								countryArea: shippingAddress.countryArea,
								firstName: shippingAddress.firstName,
								lastName: shippingAddress.lastName,
								phone: shippingAddress.phone,
								postalCode: shippingAddress.postalCode,
								streetAddress1: shippingAddress.streetAddress1,
								streetAddress2: shippingAddress.streetAddress2,
								placeId: shippingAddress.placeId,
								longitude: shippingAddress.longitude,
								latitude: shippingAddress.latitude,
							},
						},
					};
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.createCheckoutMutation,
						variables,
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_c =
							data === null || data === void 0
								? void 0
								: data.checkoutCreate) === null || _c === void 0
							? void 0
							: _c.errors.length
					) {
						return {
							error:
								(_d =
									data === null || data === void 0
										? void 0
										: data.checkoutCreate) === null || _d === void 0
									? void 0
									: _d.errors,
						};
					} else if (
						(_e =
							data === null || data === void 0
								? void 0
								: data.checkoutCreate) === null || _e === void 0
							? void 0
							: _e.checkout
					) {
						return {
							data: this.constructCheckoutModel(data.checkoutCreate.checkout),
						};
					}
				} catch (error) {
					return {
						error,
					};
				}
				return {};
			});
		this.setCartItem = (checkout) =>
			__awaiter(this, void 0, void 0, function* () {
				var _f, _g, _h;
				const checkoutId = checkout.id;
				const lines = checkout.lines;
				if (checkoutId && lines) {
					const alteredLines = lines.map((line) => ({
						quantity: line.quantity,
						variantId: line.variant.id,
					}));
					try {
						const {data, errors} = yield this.client.mutate({
							mutation: CheckoutMutations.updateCheckoutLineMutation,
							variables: {
								checkoutId,
								lines: alteredLines,
							},
						});
						if (errors === null || errors === void 0 ? void 0 : errors.length) {
							return {
								error: errors,
							};
						} else if (
							(_f =
								data === null || data === void 0
									? void 0
									: data.checkoutLinesUpdate) === null || _f === void 0
								? void 0
								: _f.errors.length
						) {
							return {
								error:
									(_g =
										data === null || data === void 0
											? void 0
											: data.checkoutLinesUpdate) === null || _g === void 0
										? void 0
										: _g.errors,
							};
						} else if (
							(_h =
								data === null || data === void 0
									? void 0
									: data.checkoutLinesUpdate) === null || _h === void 0
								? void 0
								: _h.checkout
						) {
							return {
								data: this.constructCheckoutModel(
									data.checkoutLinesUpdate.checkout,
								),
							};
						}
					} catch (error) {
						return {
							error,
						};
					}
				}
				return {};
			});
		this.setShippingAddress = (shippingAddress, email, checkoutId) =>
			__awaiter(this, void 0, void 0, function* () {
				var _j, _k, _l, _m, _o, _p;
				try {
					const variables = {
						checkoutId,
						email,
						shippingAddress: {
							id: shippingAddress.id || null,
							city: shippingAddress.city,
							companyName: shippingAddress.companyName,
							country:
								globalTypes_1.CountryCode[
									(_j =
										shippingAddress === null || shippingAddress === void 0
											? void 0
											: shippingAddress.country) === null || _j === void 0
										? void 0
										: _j.code
								],
							countryArea: shippingAddress.countryArea,
							firstName: shippingAddress.firstName,
							lastName: shippingAddress.lastName,
							phone: shippingAddress.phone,
							postalCode: shippingAddress.postalCode,
							streetAddress1: shippingAddress.streetAddress1,
							streetAddress2: shippingAddress.streetAddress2,
							placeId: shippingAddress.placeId,
							longitude: shippingAddress.longitude,
							latitude: shippingAddress.latitude,
						},
					};
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.updateCheckoutShippingAddressMutation,
						variables,
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_k =
							data === null || data === void 0
								? void 0
								: data.checkoutEmailUpdate) === null || _k === void 0
							? void 0
							: _k.errors.length
					) {
						return {
							error:
								(_l =
									data === null || data === void 0
										? void 0
										: data.checkoutEmailUpdate) === null || _l === void 0
									? void 0
									: _l.errors,
						};
					} else if (
						(_m =
							data === null || data === void 0
								? void 0
								: data.checkoutShippingAddressUpdate) === null || _m === void 0
							? void 0
							: _m.errors.length
					) {
						return {
							error:
								(_o =
									data === null || data === void 0
										? void 0
										: data.checkoutShippingAddressUpdate) === null ||
								_o === void 0
									? void 0
									: _o.errors,
						};
					} else if (
						(_p =
							data === null || data === void 0
								? void 0
								: data.checkoutShippingAddressUpdate) === null || _p === void 0
							? void 0
							: _p.checkout
					) {
						return {
							data: this.constructCheckoutModel(
								data.checkoutShippingAddressUpdate.checkout,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.setBillingAddress = (billingAddress, checkoutId) =>
			__awaiter(this, void 0, void 0, function* () {
				var _q, _r, _s, _t;
				try {
					const variables = {
						billingAddress: {
							id: billingAddress.id || null,
							city: billingAddress.city,
							companyName: billingAddress.companyName,
							country:
								globalTypes_1.CountryCode[
									(_q =
										billingAddress === null || billingAddress === void 0
											? void 0
											: billingAddress.country) === null || _q === void 0
										? void 0
										: _q.code
								],
							countryArea: billingAddress.countryArea,
							firstName: billingAddress.firstName,
							lastName: billingAddress.lastName,
							phone: billingAddress.phone,
							postalCode: billingAddress.postalCode,
							streetAddress1: billingAddress.streetAddress1,
							streetAddress2: billingAddress.streetAddress2,
							placeId: billingAddress.placeId,
							longitude: billingAddress.longitude,
							latitude: billingAddress.latitude,
						},
						checkoutId,
					};
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.updateCheckoutBillingAddressMutation,
						variables,
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_r =
							data === null || data === void 0
								? void 0
								: data.checkoutBillingAddressUpdate) === null || _r === void 0
							? void 0
							: _r.errors.length
					) {
						return {
							error:
								(_s =
									data === null || data === void 0
										? void 0
										: data.checkoutBillingAddressUpdate) === null ||
								_s === void 0
									? void 0
									: _s.errors,
						};
					} else if (
						(_t =
							data === null || data === void 0
								? void 0
								: data.checkoutBillingAddressUpdate) === null || _t === void 0
							? void 0
							: _t.checkout
					) {
						return {
							data: this.constructCheckoutModel(
								data.checkoutBillingAddressUpdate.checkout,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.setBillingAddressWithEmail = (billingAddress, email, checkoutId) =>
			__awaiter(this, void 0, void 0, function* () {
				var _u, _v, _w, _x, _y, _z;
				try {
					const variables = {
						billingAddress: {
							id: billingAddress.id || null,
							city: billingAddress.city,
							companyName: billingAddress.companyName,
							country:
								globalTypes_1.CountryCode[
									(_u =
										billingAddress === null || billingAddress === void 0
											? void 0
											: billingAddress.country) === null || _u === void 0
										? void 0
										: _u.code
								],
							countryArea: billingAddress.countryArea,
							firstName: billingAddress.firstName,
							lastName: billingAddress.lastName,
							phone: billingAddress.phone,
							postalCode: billingAddress.postalCode,
							streetAddress1: billingAddress.streetAddress1,
							streetAddress2: billingAddress.streetAddress2,
							placeId: billingAddress.placeId,
							longitude: billingAddress.longitude,
							latitude: billingAddress.latitude,
						},
						checkoutId,
						email,
					};
					const {data, errors} = yield this.client.mutate({
						mutation:
							CheckoutMutations.updateCheckoutBillingAddressWithEmailMutation,
						variables,
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_v =
							data === null || data === void 0
								? void 0
								: data.checkoutEmailUpdate) === null || _v === void 0
							? void 0
							: _v.errors.length
					) {
						return {
							error:
								(_w =
									data === null || data === void 0
										? void 0
										: data.checkoutEmailUpdate) === null || _w === void 0
									? void 0
									: _w.errors,
						};
					} else if (
						(_x =
							data === null || data === void 0
								? void 0
								: data.checkoutBillingAddressUpdate) === null || _x === void 0
							? void 0
							: _x.errors.length
					) {
						return {
							error:
								(_y =
									data === null || data === void 0
										? void 0
										: data.checkoutBillingAddressUpdate) === null ||
								_y === void 0
									? void 0
									: _y.errors,
						};
					} else if (
						(_z =
							data === null || data === void 0
								? void 0
								: data.checkoutBillingAddressUpdate) === null || _z === void 0
							? void 0
							: _z.checkout
					) {
						return {
							data: this.constructCheckoutModel(
								data.checkoutBillingAddressUpdate.checkout,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.setShippingMethod = (
			shippingMethodId,
			checkoutId,
			deliveryType,
			deliverySchedules,
			note,
		) =>
			__awaiter(this, void 0, void 0, function* () {
				var _0, _1, _2;
				try {
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.updateCheckoutShippingMethodMutation,
						variables: {
							checkoutId,
							shippingMethodId,
							deliveryType,
							deliverySchedules,
							note,
						},
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_0 =
							data === null || data === void 0
								? void 0
								: data.checkoutShippingMethodUpdate) === null || _0 === void 0
							? void 0
							: _0.errors.length
					) {
						return {
							error:
								(_1 =
									data === null || data === void 0
										? void 0
										: data.checkoutShippingMethodUpdate) === null ||
								_1 === void 0
									? void 0
									: _1.errors,
						};
					} else if (
						(_2 =
							data === null || data === void 0
								? void 0
								: data.checkoutShippingMethodUpdate) === null || _2 === void 0
							? void 0
							: _2.checkout
					) {
						return {
							data: this.constructCheckoutModel(
								data.checkoutShippingMethodUpdate.checkout,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.addPromoCode = (promoCode, checkoutId) =>
			__awaiter(this, void 0, void 0, function* () {
				var _3, _4, _5;
				try {
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.addCheckoutPromoCode,
						variables: {checkoutId, promoCode},
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_3 =
							data === null || data === void 0
								? void 0
								: data.checkoutAddPromoCode) === null || _3 === void 0
							? void 0
							: _3.errors.length
					) {
						return {
							error:
								(_4 =
									data === null || data === void 0
										? void 0
										: data.checkoutAddPromoCode) === null || _4 === void 0
									? void 0
									: _4.errors,
						};
					} else if (
						(_5 =
							data === null || data === void 0
								? void 0
								: data.checkoutAddPromoCode) === null || _5 === void 0
							? void 0
							: _5.checkout
					) {
						return {
							data: this.constructCheckoutModel(
								data.checkoutAddPromoCode.checkout,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.removePromoCode = (promoCode, checkoutId) =>
			__awaiter(this, void 0, void 0, function* () {
				var _6, _7, _8;
				try {
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.removeCheckoutPromoCode,
						variables: {checkoutId, promoCode},
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_6 =
							data === null || data === void 0
								? void 0
								: data.checkoutRemovePromoCode) === null || _6 === void 0
							? void 0
							: _6.errors.length
					) {
						return {
							error:
								(_7 =
									data === null || data === void 0
										? void 0
										: data.checkoutRemovePromoCode) === null || _7 === void 0
									? void 0
									: _7.errors,
						};
					} else if (
						(_8 =
							data === null || data === void 0
								? void 0
								: data.checkoutRemovePromoCode) === null || _8 === void 0
							? void 0
							: _8.checkout
					) {
						return {
							data: this.constructCheckoutModel(
								data.checkoutRemovePromoCode.checkout,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.createPayment = (
			amount,
			checkoutId,
			paymentGateway,
			paymentToken,
			billingAddress,
		) =>
			__awaiter(this, void 0, void 0, function* () {
				var _9, _10, _11, _12;
				try {
					const variables = {
						checkoutId,
						paymentInput: {
							amount,
							billingAddress: {
								city: billingAddress.city,
								companyName: billingAddress.companyName,
								country:
									globalTypes_1.CountryCode[
										(_9 =
											billingAddress === null || billingAddress === void 0
												? void 0
												: billingAddress.country) === null || _9 === void 0
											? void 0
											: _9.code
									],
								countryArea: billingAddress.countryArea,
								firstName: billingAddress.firstName,
								lastName: billingAddress.lastName,
								phone: billingAddress.phone,
								postalCode: billingAddress.postalCode,
								streetAddress1: billingAddress.streetAddress1,
								streetAddress2: billingAddress.streetAddress2,
								placeId: billingAddress.placeId,
								longitude: billingAddress.longitude,
								latitude: billingAddress.latitude,
							},
							gateway: paymentGateway,
							token: paymentToken,
						},
					};
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.createCheckoutPaymentMutation,
						variables,
					});
					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_10 =
							data === null || data === void 0
								? void 0
								: data.checkoutPaymentCreate) === null || _10 === void 0
							? void 0
							: _10.errors.length
					) {
						return {
							error:
								(_11 =
									data === null || data === void 0
										? void 0
										: data.checkoutPaymentCreate) === null || _11 === void 0
									? void 0
									: _11.errors,
						};
					} else if (
						(_12 =
							data === null || data === void 0
								? void 0
								: data.checkoutPaymentCreate) === null || _12 === void 0
							? void 0
							: _12.payment
					) {
						return {
							data: this.constructPaymentModel(
								data.checkoutPaymentCreate.payment,
							),
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.completeCheckout = (checkoutId, checkoutNotes) =>
			__awaiter(this, void 0, void 0, function* () {
				var _13, _14, _15;
				try {
					const {data, errors} = yield this.client.mutate({
						mutation: CheckoutMutations.completeCheckoutMutation,
						variables: {checkoutId, checkoutNotes},
					});

					if (errors === null || errors === void 0 ? void 0 : errors.length) {
						return {
							error: errors,
						};
					} else if (
						(_13 =
							data === null || data === void 0
								? void 0
								: data.checkoutComplete) === null || _13 === void 0
							? void 0
							: _13.errors.length
					) {
						return {
							error:
								(_14 =
									data === null || data === void 0
										? void 0
										: data.checkoutComplete) === null || _14 === void 0
									? void 0
									: _14.errors,
						};
					} else if (
						(_15 =
							data === null || data === void 0
								? void 0
								: data.checkoutComplete) === null || _15 === void 0
							? void 0
							: _15.orders
					) {
						return {
							data: this.constructOrderModel(data.checkoutComplete.orders),
							paymentRedirectUrl: data.checkoutComplete
								? data.checkoutComplete.paymentRedirectUrl
								: null,
						};
					} else {
						return {};
					}
				} catch (error) {
					return {
						error,
					};
				}
			});
		this.isLoggedIn = () => {
			return !!auth_1.getAuthToken();
		};
		this.constructCheckoutModel = ({
			id,
			token,
			email,
			shippingAddress,
			billingAddress,
			discount,
			discountName,
			voucherCode,
			lines,
			availableShippingMethods,
			shippingMethod,
			deliveryQuotations,
			currentDatetime,
			note,
			paymentTransactionType,
		}) => ({
			availableShippingMethods: availableShippingMethods
				? availableShippingMethods.filter(utils_1.filterNotEmptyArrayItems)
				: [],
			billingAddress,
			email,
			id,
			lines:
				lines === null || lines === void 0
					? void 0
					: lines
							.filter(
								(item) =>
									(item === null || item === void 0 ? void 0 : item.quantity) &&
									item.variant.id,
							)
							.map((item) => {
								const itemVariant =
									item === null || item === void 0 ? void 0 : item.variant;
								return {
									id: item.id,
									quantity: item.quantity,
									totalPrice:
										item === null || item === void 0 ? void 0 : item.totalPrice,
									variant: {
										attributes:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.attributes,
										id: itemVariant.id,
										isAvailable:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.isAvailable,
										name:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.name,
										pricing:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.pricing,
										product:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.product,
										quantityAvailable:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.quantityAvailable,
										sku:
											itemVariant === null || itemVariant === void 0
												? void 0
												: itemVariant.sku,
									},
								};
							}),
			promoCodeDiscount: {
				discount,
				discountName,
				voucherCode,
			},
			shippingAddress,
			shippingMethod,
			token,
			deliveryQuotations,
			currentDatetime,
			note,
			paymentTransactionType,
		});
		this.constructPaymentModel = ({id, gateway, token, creditCard}) => ({
			creditCard,
			gateway,
			id,
			token,
		});
		// this.constructOrderModel = ({ id, token, number: orderNumber, orderReference }) => ({
		//     id,
		//     number: orderReference,
		//     token,
		// });
		this.constructOrderModel = (data) => {
			if (!data || !data.length) {
				return [];
			}

			return data.map(({id, token, number: orderNumber, orderReference}) => ({
				id,
				number: orderReference,
				token,
			}));
		};
		this.client = client;
	}
}
exports.ApolloClientManager = ApolloClientManager;
//# sourceMappingURL=index.js.map
